'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SimpleMap = exports.SimpleMap = function () {
  function SimpleMap() {
    _classCallCheck(this, SimpleMap);

    this.size = 0;
    this.keys = [];
    this.values = [];
  }

  SimpleMap.prototype.get = function get(key) {
    var index = this.keys.indexOf(key);

    return this.values[index];
  };

  SimpleMap.prototype.set = function set(key, value) {
    this.keys.push(key);
    this.values.push(value);
    this.size = this.keys.length;

    return value;
  };

  return SimpleMap;
}();

var exportedMap = typeof Map === 'undefined' ? SimpleMap : Map;

exports.default = exportedMap;


/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/react-css-modules/dist/simple-map.js
 ** module id = 2427
 ** module chunks = 0
 **/